<template>
    <div class="settings-panel">
        <div class="settings-panel__inner">
            <mds-section
                :size="7"
                collapsible
                bold
                ref="section"
                border="secondary"
                @mds-section-expanded="expandSection"
                @mds-section-closed="closeSection"
                e2e="time-period-section"
            >
                <template v-slot:mds-section-title>
                    {{ getUILabel(text) }}
                </template>
                <template v-slot:mds-section-actions>
                    <mds-switch :checked="true" :disabled="true" e2e="time-period-switch">
                        {{ getUILabel("common_include") }}
                    </mds-switch>
                </template>
                <template v-slot:default>
                    <holdings-content
                        :mwcId="getMwcIdForChild('content')"
                        ref="content"
                        :isPortfolioComparison="isPortfolioComparison"
                        :portfolioList="portfolioList"
                        :globalAvailableDates="globalAvailableDates"
                        :globalTimePeriod="globalTimePeriod"
                        :customTimePeriodDates="customTimePeriodDates"
                        @global-time-period-changed="handleGlobalTimePeriodChanged"
                        @security-time-period-changed="handleSecurityTimePeriodChanged"
                    >
                    </holdings-content>
                </template>
            </mds-section>
            <holdings-summary v-if="!expanded" :mwcId="getMwcIdForChild('summary')" :globalTimePeriod="globalTimePeriod"></holdings-summary>
        </div>
    </div>
</template>

<script>
import HypoVueBaseMixin from "hypo-vue-base-mixin";
import HoldingsSummary from "./Summary";
import HoldingsContent from "./Holdings";
import MwcSharedMixin from "@/mixins/MwcSharedMixin";
import MdsSection from "@mds/section";
import MdsSwitch from "@mds/switch";

export default {
    name: "holdings-panel",
    props: {
        text: String,
        isPortfolioComparison: {
            type: Boolean,
            default: false
        },
        portfolioList: Array,
        globalAvailableDates: Object,
        globalTimePeriod: [Number, String],
        customTimePeriodDates: [Object]
    },
    components: {
        HoldingsSummary,
        HoldingsContent,
        MdsSection,
        MdsSwitch
    },
    mixins: [HypoVueBaseMixin, MwcSharedMixin],
    data() {
        return {
            defaultConfig: {
                labels: this.$store.state.labels.labels
            },
            expanded: false
        };
    },
    methods: {
        expandSection() {
            this.expanded = true;
        },
        closeSection() {
            this.expanded = false;
        },
        handleGlobalTimePeriodChanged(payload) {
            this.$emit("global-time-period-changed", payload);
        },
        handleSecurityTimePeriodChanged(payload) {
            this.$emit("security-time-period-changed", payload);
        }
    }
};
</script>
